import { searchandiser } from './pkg-index';

export = searchandiser;



// WEBPACK FOOTER //
// ./~/source-map-loader!./~/source-map-loader!./src/index.ts